import { ClockSmallIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { getDate } from "../../../utils/getStrDate";
import { getTime } from "../../../utils/getStrTime";
import { getShiftDurationHours } from "../../../utils/getShiftDurationHours";
import { useParams } from "react-router";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import TableAPI from "../../../api/TableAPI";

import styles from "./weekDayPopup.module.css";

import { Text } from "../../../components/text/text";

const weekDays = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];

export const WeekDayPopup = ({ date, shift, onDelete }) => {
    const { cafeId, userId } = useParams();
    const weekDay = (date.getDay() + 6) % 7;

    let startTime, endTime, durationHours;

    if (shift) {
        const startTimeComponents = shift.startTime.split(":")
        startTime = new Date(
            1970, 0, 1,
            startTimeComponents[0],
            startTimeComponents[1],
            startTimeComponents[2]
        )

        const endTimeComponents = shift.endTime.split(":")
        endTime = new Date(
            1970, 0, 1,
            endTimeComponents[0],
            endTimeComponents[1],
            endTimeComponents[2]
        )

        durationHours = getShiftDurationHours(shift.startTime, shift.endTime)
    }

    const onCancelShift = () => {
        if (!cafeId) return;
        TableAPI
            .cancelShift(cafeId, userId, date)
            .then(() => onDelete(date))
            .catch(console.error);
    }

    const navigate = useAnimatedNavigate();

    if (!shift) {
        return (
            <>
                <div className={styles.shift_date_container}>
                    <Text as="div" variant="h1" className={styles.shift_date_title} >
                        {weekDays[weekDay]} {getDate(date)}
                    </Text>
                    <Text as="div" variant="h3" className={styles.shift_date_subtitle} size={14} lineHeight="1">Смены нет</Text>
                </div>

                <Button
                    text="Добавить смену"
                    onClick={() => navigate(`add?date=${date.toISOString().split("T")[0]}`)}
                />
            </>
        );
    }

    return (
        <>
            <div className={styles.shift_date_container}>
                <Text as="div" variant="h1" className={styles.shift_date_title} >
                    {weekDays[weekDay]} {getDate(date)}
                </Text>
                <Text as="div" variant="h3" className={styles.shift_date_subtitle} size={14} lineHeight="1">Рабочая смена</Text>
            </div>

            <div className={styles.shift_info_container}>
                <ClockSmallIcon />
                <Text as="div" variant="body" className={styles.shift_info_text} >c {getTime(startTime)} до {getTime(endTime)} ({durationHours} часов)</Text>
            </div>

            <Button
                type="destructive"
                text="Отменить смену"
                onClick={onCancelShift}
            />
        </>
    );
}
